/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 *
 */
let baseUrlProxy = ''
let baseUrl = ''
let routerMode = 'history'
let baseImgPath = ''
let baseWebSocketPath = ''
let baseUploadUrl = ''
let loginUrl = baseUrl = window.location.protocol + '//' + window.location.host

if (process.env.NODE_ENV === 'development') {
  baseUrlProxy = '/'
  // baseUrlProxy = 'http://192.168.23.125:8081'

  // baseUrl = 'http://192.168.32.187'
  // baseImgPath = 'http://192.168.32.187'
  // baseWebSocketPath = '192.168.32.187'

  baseUrl = 'http://127.0.0.1:8081'
  baseImgPath = 'http://127.0.0.1:8081'
  baseWebSocketPath = '127.0.0.1:8081'
} else {
  baseUrlProxy = window.location.protocol + '//' + window.location.host
  baseUrl = window.location.protocol + '//' + window.location.host
  baseImgPath = window.location.protocol + '//' + window.location.host
  baseWebSocketPath = window.location.host
}
baseUploadUrl = baseUrlProxy + '/hgSafetyWeb/upload/img'
export {
  baseUrlProxy,
  loginUrl,
  baseUrl,
  routerMode,
  baseImgPath,
  baseUploadUrl,
  baseWebSocketPath
}
